import axios from "axios";

const selfClient = axios.create({
    baseURL: `${process.env.REACT_APP_SELF_APP_WAS}`,
    responseType: "json",
    withCredentials: true
});

export default selfClient;